import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/Home.vue')
  },
  {
    path: '/home-copy',
    meta: {title: "卡权益"},
    name: 'Home-copy',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/home-copy.vue')
  },
  // 我的
  {
    path: '/my',
    name: 'My',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/home/My.vue')
  },
  // 卡权益
  {
    path: '/card-ecommend',
    name: 'Card-ecommend',
    component: () => import('../views/card/card-ecommend.vue')
  },
  // 买卡
  {
    path: '/buy-card',
    name: 'Buy-card',
    component: () => import('../views/card/buy-card.vue')
  },
  // 充值
  {
    path: '/pay',
    name: 'Pay',
    component: () => import('../views/pay/Pay.vue')
  },
  // 分享
  // {
  //   path: '/share',
  //   name: 'Share',
  //   component: () => import('../views/home/Share.vue')
  // },
  // 完善个人信息
  {
    path: '/perfect',
    name: 'Perfect',
    component: () => import('../views/information/Perfect.vue')
  },
  // 订单列表
  {
    path: '/order-list',
    name: 'Order-list',
    component: () => import('../views/order/order-list.vue'),
  },
  // 订单详情
  {
    path: '/order-more',
    name: 'Order-more',
    component: () => import('../views/order/order-more.vue')
  },
  // 活动详情
  {
    path: '/activity-detail',
    name: 'Activity-detail',
    component: () => import('../views/activity/activity-detail.vue')
  },
  // 粉丝管理
  {
    path: '/fans',
    name: 'Fans',
    component: () => import('../views/fans/Fans.vue')
  },
  // 我的积分
  {
    path: '/my-jifen',
    name: 'My-jifen',
    component: () => import('../views/home/my-jifen.vue'),
    children: [
      {
        path: '/',
        name: 'login-score',
        component: () => import('../views/score/login-score.vue'),
      },
      {
        path: 'award-score',
        name: 'award-score',
        component: () => import('../views/score/award-score.vue'),
      },
    ]
  },
  // 申请合伙人
  // {
  //   path: '/apply-partner',
  //   name: 'Apply-partner',
  //   component: () => import('../views/partner/apply-partner.vue'),
  //   // children: [
  //   //   {
  //   //     path: '/',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
  //   //     name: 'write-msg',
  //   //     component: () => import('../views/partner/write-msg.vue'),
  //   //   },
  //   //   {
  //   //     path: 'sign-contract',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
  //   //     name: 'sign-contract',
  //   //     component: () => import('../views/partner/sign-contract.vue'),
  //   //   },
  //   //   {
  //   //     path: 'authentication',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
  //   //     name: 'authentication',
  //   //     component: () => import('../views/partner/authentication.vue'),
  //   //   },
  //   // ]
  // },
  // 申请合伙人信息填写
  {
    path: '/write-msg',
    name: 'write-msg',
    component: () => import('../views/partner/write-msg.vue'),
  },
  // 申请合伙人协议
  {
    path: '/sign-contract',
    name: 'sign-contract',
    component: () => import('../views/partner/sign-contract.vue'),
  },
  // 申请合伙人完成认证
  {
    path: '/authentication',
    name: 'authentication',
    component: () => import('../views/partner/authentication.vue'),
  },
  // 申请合伙人查看认证详情
  {
    path: '/review-details',
    name: 'review-details',
    component: () => import('../views/partner/review-details.vue'),
  },
  // 申请商家信息填写
  {
    path: '/business-information',
    name: 'business-information',
    component: () => import('../views/merchant/business-information.vue'),
  },
  // 申请商家协议合同
  {
    path: '/business-contract',
    name: 'business-contract',
    component: () => import('../views/merchant/business-contract.vue'),
  },
  // 商家申请进度
  {
    path: '/business-progress',
    name: 'business-progress',
    component: () => import('../views/merchant/business-progress.vue'),
  },
  // 商家申请进度查看
  {
    path: '/schedule-details',
    name: 'schedule-details',
    component: () => import('../views/merchant/schedule-details.vue'),
  },
  // 合伙人个人中心
  {
    path: '/partner-information',
    name: 'partner-information',
    component: () => import('../views/partner/partner-information.vue'),
  },
  // 收益明细
  {
    path: '/returns-detailed',
    name: 'returns-detailed',
    component: () => import('../views/partner-information/returns-detailed.vue'),
    children: [
      {
        path: '/',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'health-integral',
        component: () => import('../views/partner-information/health-integral.vue'),
      },
      {
        path: 'job-options',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'job-options',
        component: () => import('../views/partner-information/job-options.vue'),
      },
      {
        path: 'performance-options',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'performance-options',
        component: () => import('../views/partner-information/performance-options.vue'),
      },
    ]
  },
  // 支付成功
  {
    path: '/pay-success',
    name: 'Pay-success',
    component: () => import('../views/pay/pay-success.vue')
  },
  // 充值记录
  {
    path: '/pay-record',
    name: 'Pay-record',
    component: () => import('../views/pay/pay-record.vue'),
  },
  {
    path: '/landlord-bill',
    name: 'landlord-bill',
    component: () => import('../views/bill/landlord-bill.vue')
  },
  // 佣金
  {
    path: '/brokerage',
    name: 'Brokerage',
    component: () => import('../views/brokerage/brokerage.vue'),
    children: [
      {
        path: '/',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'member-income',
        component: () => import('../views/brokerage/member-income.vue'),
      },
      {
        path: 'expenditure-income',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'expenditure-income',
        component: () => import('../views/brokerage/expenditure-income.vue'),
      },
    ]
  },
  // 提现
  {
    path: '/withdraw-deposit',
    name: 'Withdraw-deposit',
    component: () => import('../views/pay/withdraw-deposit.vue')
  },
  // 提现记录
  {
    path: '/withdrawal-record',
    name: 'Withdrawal-record',
    component: () => import('../views/pay/withdrawal-record.vue')
  },
  {
    path: '/binding-iphone',
    name: 'binding-iphone',
    component: () => import('../views/home/binding-iphone.vue')
  },
  {
    path: '/integral-withdraw-deposit',
    name: 'integral-withdraw-deposit',
    component: () => import('../views/pay/integral-withdraw-deposit.vue')
  },
  // 引流
  {
    path: '/redirect',
    name: 'redirect',
    component: () => import('../views/redirect/redirect.vue')
  },
  // 运营数据中心
  {
    path: '/admin-data',
    name: 'admin-data',
    component: () => import('../views/data/admin-data.vue')
  },
  // 用户数据中心
  {
    path: '/user-data',
    name: 'user-data',
    component: () => import('../views/data/user-data.vue')
  },
  // 钱包
  {
    path: '/wallet',
    name: 'wallet',
    component: () => import('../views/wallet/wallet.vue'),
    children: [
      {
        path: '/',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'recharge',
        component: () => import('../views/wallet/recharge.vue'),
      },
      {
        path: 'income',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'income',
        component: () => import('../views/wallet/income.vue'),
      },
      {
        path: 'wallet-brokerage',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
        name: 'wallet-brokerage',
        component: () => import('../views/wallet/wallet-brokerage.vue'),
      },
    ]
  },
  // 用户数据中心
  {
    path: '/my-team',
    name: 'my-team',
    component: () => import('../views/partner-information/my-team.vue')
  },
  {
    path: '/sell-card',
    name: 'sell-card',
    component: () => import('../views/partner-information/sell-card.vue')
  },
  {
    path: '/jifen',
    name: 'Jifen',
    component: () => import('../views/jifen/jifen.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// router.beforeEach((to, from, next) => {
//   if(to.meta.tile){
//     document.title = to.meta.tile
//   }
// })
export default router
